import React, { useState } from 'react'
import { UpgradePlanModalContext } from '../../utils/contexts'

const UpgradePlanModalProvider = ({ children }) => {
  const [show, setShow] = useState(false)
  const [data, setData] = useState(null)
  const onHide = () => {
    setShow(false)
  }
  const onShow = () => {
    setShow(true)
  }

  const setModalData = (data) => {
    setData(data)
  }

  return (
    <UpgradePlanModalContext.Provider
      value={{
        show: show,
        data: data,
        onShow: onShow,
        onHide: onHide,
        setModalData: setModalData,
      }}>
      {children}
    </UpgradePlanModalContext.Provider>
  )
}

export default UpgradePlanModalProvider
